<div *ngIf="showDiv">
  <div class="d-flex data-filter-wrap">
    <ul class="d-flex mr-auto data-filter">
      <li [class.active]="typeId==1">Show : <a (click)="changeFlow(1)" href="javascript:void(0)">Income Statement</a></li>
      <li [class.active]="typeId==2"><a (click)="changeFlow(2)" href="javascript:void(0)">Balance Sheet</a></li>
      <li [class.active]="typeId==3"><a (click)="changeFlow(3)" href="javascript:void(0)">Cash Flow</a></li>
    </ul>
    <ul class="d-flex data-filter">
      <li [class.active]="period==12"><a href="javascript:void(0)" (click)="changePeriod(12)">Annual</a></li>
      <li [class.active]="period==3"><a href="javascript:void(0)" (click)="changePeriod(3)">Quarterly</a></li>
    </ul>

  </div>

  <div *ngIf="typeId==1">
    <h3 class="bluelabel" style="margin:15px 0"> Income Statement &nbsp;&nbsp; <span style="font-size:8px;">All numbers in thousands</span></h3>
    <div class="table-responsive">
      <table class="table basictable row-border hover  finance-data-table">
        <thead>
          <tr>
            <th width="300px">Breakdown</th>
            <th>TTM</th>
            <th *ngFor="let item of dates">
              {{item | date:'MM/dd/yyyy'}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total Revenue</td>
            <td>{{IncomeStatement?.trailingTotalRevenue?.length >0 ?getTrailingValuesValue(IncomeStatement['trailingTotalRevenue']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualTotalRevenue'],item) :getValue(IncomeStatement['quarterlyTotalRevenue'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Cost of Revenue</td>
            <td>{{IncomeStatement?.trailingCostOfRevenue?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingCostOfRevenue']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualCostOfRevenue'],item) :getValue(IncomeStatement['quarterlyCostOfRevenue'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Gross Profit</td>
            <td>{{IncomeStatement?.trailingGrossProfit?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingGrossProfit']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualGrossProfit'],item) :getValue(IncomeStatement['quarterlyGrossProfit'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td class="border-left">
              <span class="btn-collapse" (click)="opExpense = !opExpense">
                <i class="fa fa-angle-right" *ngIf="opExpense" aria-hidden="true"></i>
                <i class="fa fa-angle-down" *ngIf="!opExpense" aria-hidden="true"></i>
              </span>Operating Expenses
            </td>
            <td>
              <p class="d-flex" *ngIf="opExpense">
                {{freeCashFlow(IncomeStatement?.trailingResearchAndDevelopment?.length > 0 ? (IncomeStatement?.trailingResearchAndDevelopment && IncomeStatement?.trailingResearchAndDevelopment[0]?.reportedValue.raw):0, IncomeStatement?.trailingSellingGeneralAndAdministration?.length > 0 ? (IncomeStatement?.trailingSellingGeneralAndAdministration && IncomeStatement?.trailingSellingGeneralAndAdministration[0]?.reportedValue.raw):0)| shortNumber}}
              </p>
            </td>
            <ng-container>
              <td *ngFor="let item of dates">
                <p class="d-flex" *ngIf="opExpense&& period==3">
                  {{freeCashFlow( getValue(IncomeStatement['quarterlySellingGeneralAndAdministration'],item), getValue(IncomeStatement['quarterlyResearchAndDevelopment']))}}
                </p>
                <p class="d-flex" *ngIf="opExpense&& period==12">
                  {{freeCashFlow( getValue(IncomeStatement['annualSellingGeneralAndAdministration'],item), getValue(IncomeStatement['annualResearchAndDevelopment']))}}
                </p>
              </td>
            </ng-container>
          </tr>
          <ng-container *ngIf="!opExpense">
            <tr class="td-collapse">

              <td>
                Research Development
              </td>
              <td>{{IncomeStatement?.trailingResearchAndDevelopment?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingResearchAndDevelopment']):'-'}}</td>
              <ng-container>
                <td *ngFor="let item of dates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(IncomeStatement['annualResearchAndDevelopment'],item) :getValue(IncomeStatement['quarterlyResearchAndDevelopment'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <tr class="td-collapse">

              <td>
                Selling General And Administrative
              </td>
              <td>{{IncomeStatement?.trailingSellingGeneralAndAdministration?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingSellingGeneralAndAdministration']):'-'}}</td>
              <ng-container>
                <td *ngFor="let item of dates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(IncomeStatement['annualSellingGeneralAndAdministration'],item) :getValue(IncomeStatement['quarterlySellingGeneralAndAdministration'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <tr>
              <td><h3 class="bluelabel">Total Operating Expenses</h3></td>
              <td>
                <p class="d-flex">
                  {{freeCashFlow(IncomeStatement?.trailingResearchAndDevelopment.length > 0 ? (IncomeStatement?.trailingResearchAndDevelopment && IncomeStatement?.trailingResearchAndDevelopment[0]?.reportedValue.raw):0, IncomeStatement?.trailingSellingGeneralAndAdministration.length > 0 ? (IncomeStatement?.trailingSellingGeneralAndAdministration && IncomeStatement?.trailingSellingGeneralAndAdministration[0]?.reportedValue.raw):0)| shortNumber}}
                </p>
              </td>
              <ng-container>
                <td *ngFor="let item of dates">
                  <p class="d-flex" *ngIf="period==3">
                    {{freeCashFlow( getValue(IncomeStatement['quarterlySellingGeneralAndAdministration'],item), getValue(IncomeStatement['quarterlyResearchAndDevelopment']))}}
                  </p>
                  <p class="d-flex" *ngIf="period==12">
                    {{freeCashFlow( getValue(IncomeStatement['annualSellingGeneralAndAdministration'],item), getValue(IncomeStatement['annualResearchAndDevelopment']))}}
                  </p>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr>
            <td>Operating Expenses</td>
            <td>{{IncomeStatement?.trailingOperatingExpense?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingOperatingExpense']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualOperatingExpense'],item) :getValue(IncomeStatement['quarterlyOperatingExpense'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Operating Income</td>
            <td>{{IncomeStatement?.trailingOperatingIncome?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingOperatingIncome']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualOperatingIncome'],item) :getValue(IncomeStatement['quarterlyOperatingIncome'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Interest Expense</td>
            <td>{{IncomeStatement?.trailingInterestExpense?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingInterestExpense']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualInterestExpense'],item) :getValue(IncomeStatement['quarterlyInterestExpense'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>
              Total Other Income/Expenses Net
            </td>
            <td>{{IncomeStatement?.trailingOtherIncomeExpense?.length > 0?getTrailingValuesValue(IncomeStatement['trailingOtherIncomeExpense']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualOtherIncomeExpense'],item) :getValue(IncomeStatement['quarterlyOtherIncomeExpense'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Income Before Tax</td>
            <td>{{IncomeStatement?.trailingPretaxIncome?.length > 0 ?getTrailingValuesValue(IncomeStatement['trailingPretaxIncome']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualPretaxIncome'],item) :getValue(IncomeStatement['quarterlyPretaxIncome'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Income Tax Expense</td>
            <td>{{IncomeStatement?.trailingTaxProvision?.length > 0?getTrailingValuesValue(IncomeStatement['trailingTaxProvision']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualIncomeTaxPayable'],item) :getValue(IncomeStatement['quarterlyIncomeTaxPayable'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Income From Continuing Operations</td>
            <td>{{IncomeStatement?.trailingNetIncomeContinuousOperations?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingNetIncomeContinuousOperations']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualNetIncomeFromContinuingOperations'],item) :getValue(IncomeStatement['quarterlyNetIncomeContinuousOperations'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td><h3 class="bluelabel">Net Income</h3></td>
            <td>{{IncomeStatement?.trailingNetIncome?.length >0 ?getTrailingValuesValue(IncomeStatement['trailingNetIncome']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualNetIncome'],item) :getValue(IncomeStatement['quarterlyNetIncome'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>
              Net Income Available
              To Common Shareholders
            </td>
            <td>{{IncomeStatement?.trailingNetIncomeCommonStockholders?.length > 0 ?getTrailingValuesValue(IncomeStatement['trailingNetIncomeCommonStockholders']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualNetIncomeCommonStockholders'],item) :getValue(IncomeStatement['quarterlyNetIncomeCommonStockholders'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Basic EPS</td>
            <td>{{IncomeStatement?.trailingBasicEPS?.length > 0 ?getTrailingValuesValue(IncomeStatement['trailingBasicEPS']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualBasicEPS'],item) :getValue(IncomeStatement['quarterlyBasicEPS'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Diluted EPS</td>
            <td>{{IncomeStatement?.trailingDilutedEPS?.length > 0? getTrailingValuesValue(IncomeStatement['trailingDilutedEPS']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualDilutedEPS'],item) :getValue(IncomeStatement['quarterlyDilutedEPS'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Basic Average Shares</td>
            <td>{{IncomeStatement?.trailingBasicAverageShares?.length > 0 ?getTrailingValuesValue(IncomeStatement['trailingBasicAverageShares']):'-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualBasicAverageShares'],item) :getValue(IncomeStatement['quarterlyBasicAverageShares'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>Diluted Average Shares</td>
            <td>{{IncomeStatement?.trailingDilutedAverageShares?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingDilutedAverageShares']): '-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualDilutedAverageShares'],item) :getValue(IncomeStatement['quarterlyDilutedAverageShares'],item) }}
              </td>
            </ng-container>
          </tr>
          <tr>
            <td>EBITDA</td>
            <td>{{IncomeStatement?.trailingEBITDA?.length > 0 ? getTrailingValuesValue(IncomeStatement['trailingEBITDA']) : '-'}}</td>
            <ng-container>
              <td *ngFor="let item of dates">
                {{ period==12 ? getValue(IncomeStatement['annualEBITDA'],item) :getValue(IncomeStatement['quarterlyEbitda'],item) }}
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


  <div *ngIf="typeId==2">
    <div class="d-flex margin-bottom-10 margin-top-15">
      <h3 class="bluelabel mr-auto margin-bottom-0">Balance Sheet &nbsp;&nbsp; <span style="font-size:8px;">All numbers in thousands</span></h3>
      <a class="a-normal" (click)="expand(false)" *ngIf="!isExpanded">Expand All</a>
      <a class="a-normal" (click)="expand(true)" *ngIf="isExpanded">Collapse All</a>
    </div>


    <div class="table-responsive">
      <table class="table basictable finance-data-table row-border hover">
        <thead>
          <tr>
            <th>Breakdown</th>
            <th *ngFor="let item of balanceSheetDates">
              {{item | date:'MM/dd/yyyy'}}
            </th>
          </tr>
        </thead>

        <tbody>
          <ng-container>
            <tr class="clickable" data-toggle="collapse" data-target="#group-of-rows-1" aria-expanded="false" aria-controls="group-of-rows-1">
              <td>
                <span class="btn-collapse" (click)="assets = !assets">
                  <i class="fa fa-angle-right" *ngIf="assets" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" *ngIf="!assets" aria-hidden="true"></i>
                </span>Assets
              </td>
              <ng-container>
                <td *ngFor="let item of balanceSheetDates">
                  {{ period==12 ? getValue(BalanceSheetData['annualTotalAssets'],item) :getValue(BalanceSheetData['quarterlyTotalAssets'],item) }}
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <ng-container *ngIf="!assets">
            <tr class="td-collapse">
              <td>
                <span class="btn-collapse" (click)="currentAssets=!currentAssets">
                  <i class="fa fa-angle-right" *ngIf="currentAssets" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" *ngIf="!currentAssets" aria-hidden="true"></i>
                </span>Current Assets
              </td>
              <ng-container *ngIf="currentAssets">
                <td *ngFor="let item of balanceSheetDates">
                  {{ period==12 ? getValue(BalanceSheetData['annualCurrentAssets'],item) :getValue(BalanceSheetData['quarterlyCurrentAssets'],item) }}
                </td>
              </ng-container>
            </tr>

            <ng-container *ngIf="!currentAssets">
              <tr class="td-collapse">

                <td>
                  <span class="btn-collapse" (click)="cash=!cash">
                    <i class="fa fa-angle-right" *ngIf="cash" aria-hidden="true"></i>
                    <i class="fa fa-angle-down" *ngIf="!cash" aria-hidden="true"></i>
                  </span>Cash
                </td>
                <ng-container *ngIf="cash">
                  <td *ngFor="let item of balanceSheetDates">
                    {{ period==12 ? getValue(BalanceSheetData['annualCashAndCashEquivalents'],item) :getValue(BalanceSheetData['quarterlyCashAndCashEquivalents'],item) }}
                  </td>
                </ng-container>
              </tr>
              <ng-container *ngIf="!cash">
                <tr class="td-collapse">

                  <td>
                    Cash Equivalent
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      {{ period==12 ? getValue(BalanceSheetData['annualCashAndCashEquivalents'],item) :getValue(BalanceSheetData['quarterlyCashAndCashEquivalents'],item) }}
                    </td>
                  </ng-container>
                </tr>
                <tr class="td-collapse">

                  <td>
                    <h3 class="bluelabel">Total Cash</h3>
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      {{ period==12 ? getValue(BalanceSheetData['annualCashAndCashEquivalents'],item) :getValue(BalanceSheetData['quarterlyCashAndCashEquivalents'],item) }}
                    </td>
                  </ng-container>

                </tr>
              </ng-container>
              <tr>

                <td>
                  Net Receivables
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualReceivables'],item) :getValue(BalanceSheetData['quarterlyAccountsReceivable'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
              <tr>

                <td>
                  Inventory
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualInventory'],item) :getValue(BalanceSheetData['quarterlyInventory'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
              <tr>

                <td>
                  Other Current Assets
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualOtherCurrentAssets'],item) :getValue(BalanceSheetData['quarterlyOtherCurrentAssets'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
              <tr>

                <td>
                  <h3 class="bluelabel">Total Current Assets</h3>
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualCurrentAssets'],item) :getValue(BalanceSheetData['quarterlyCurrentAssets'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
            <ng-container>
              <tr class="td-collapse">

                <td>
                  <span class="btn-collapse" (click)="nonCurrentAssets=!nonCurrentAssets">
                    <i class="fa fa-angle-right" *ngIf="nonCurrentAssets" aria-hidden="true"></i>
                    <i class="fa fa-angle-down" *ngIf="!nonCurrentAssets" aria-hidden="true"></i>
                  </span>Non Current Assets
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex" *ngIf="nonCurrentAssets">
                      {{ period==12 ? getValue(BalanceSheetData['annualTotalNonCurrentAssets'],item) :getValue(BalanceSheetData['quarterlyTotalNonCurrentAssets'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
            <ng-container *ngIf="!nonCurrentAssets">
              <tr class="td-collapse">

                <td class="border-left">
                  <span class="btn-collapse" (click)="nonCurrentAssetsProperty=!nonCurrentAssetsProperty">
                    <i class="fa fa-angle-right" *ngIf="nonCurrentAssetsProperty" aria-hidden="true"></i>
                    <i class="fa fa-angle-down" *ngIf="!nonCurrentAssetsProperty" aria-hidden="true"></i>
                  </span>Property, Plant And Equipment
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex" *ngIf="nonCurrentAssetsProperty">
                      {{ period==12 ? getValue(BalanceSheetData['annualNetPPE'],item) :getValue(BalanceSheetData['quarterlyNetPPE'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
              <ng-container *ngIf="!nonCurrentAssetsProperty">
                <tr class="td-collapse">

                  <td>
                    Gross Property, Plant And Equipment
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualGrossPPE'],item) :getValue(BalanceSheetData['quarterlyGrossPPE'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
                <tr class="td-collapse">

                  <td>
                    Accumulated Depreciation
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualAccumulatedDepreciation'],item) :getValue(BalanceSheetData['quarterlyAccumulatedDepreciation'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
                <tr class="td-collapse">

                  <td>
                    <h3 class="bluelabel">Net Property, Plant And Equipment</h3>
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualNetPPE'],item) :getValue(BalanceSheetData['quarterlyNetPPE'],item) }}
                      </p>
                    </td>
                  </ng-container>
                <tr>

                  <td>
                    Investments and Advances
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualInvestmentsAndAdvances'],item) :getValue(BalanceSheetData['quarterlyInvestmentsAndAdvances'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
                <tr>

                  <td>
                    Goodwill
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualGoodwill'],item) :getValue(BalanceSheetData['quarterlyGoodwill'],item) }}
                      </p>
                    </td>
                  </ng-container>

                </tr>
                <tr>

                  <td>
                    Other Intangible Assets
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualOtherIntangibleAssets'],item) :getValue(BalanceSheetData['quarterlyOtherIntangibleAssets'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
                <tr>

                  <td>
                    Other Long-Term Assets
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualOtherNonCurrentAssets'],item) :getValue(BalanceSheetData['quarterlyOtherNonCurrentAssets'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
                <tr>

                  <td>
                    <h3 class="bluelabel">Total Non-Current Assets</h3>
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualOtherCurrentAssets'],item) :getValue(BalanceSheetData['quarterlyOtherCurrentAssets'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr>

                <td>
                  <h3 class="bluelabel">Total Assets</h3>
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualTotalAssets'],item) :getValue(BalanceSheetData['quarterlyTotalAssets'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container>
            <tr class="clickable">

              <td class="border-left">
                <span class="btn-collapse" (click)="liability = !liability">
                  <i class="fa fa-angle-right" *ngIf="liability" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" *ngIf="!liability" aria-hidden="true"></i>
                </span>Liabilities And Stockholders' Equity
              </td>
              <ng-container>
                <td *ngFor="let item of balanceSheetDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(BalanceSheetData['annualTotalAssets'],item) :getValue(BalanceSheetData['quarterlyTotalAssets'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
          </ng-container>

          <ng-container *ngIf="!liability">
            <tr class="td-collapse">

              <td class="border-left">
                <span class="btn-collapse" (click)="currentLiabilities = !currentLiabilities">
                  <i class="fa fa-angle-right" *ngIf="currentLiabilities" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" *ngIf="!currentLiabilities" aria-hidden="true"></i>
                </span>Liabilities
              </td>
              <ng-container>
                <td *ngFor="let item of balanceSheetDates">
                  <p class="d-flex" *ngIf="currentLiabilities">
                    {{ period==12 ? getValue(BalanceSheetData['annualCurrentLiabilities'],item) :getValue(BalanceSheetData['quarterlyCurrentLiabilities'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <ng-container *ngIf="!currentLiabilities">
              <tr class="td-collapse">

                <td class="border-left">
                  <span class="btn-collapse" (click)="curLiabilities = !curLiabilities">
                    <i class="fa fa-angle-right" *ngIf="curLiabilities" aria-hidden="true"></i>
                    <i class="fa fa-angle-down" *ngIf="!curLiabilities" aria-hidden="true"></i>
                  </span>Current Liabilities
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex" *ngIf="curLiabilities">
                      {{ period==12 ? getValue(BalanceSheetData['annualCurrentLiabilities'],item) :getValue(BalanceSheetData['quarterlyCurrentLiabilities'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
              <ng-container *ngIf="!curLiabilities">
                <tr class="td-collapse">

                  <td>
                    Accounts Payable
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualAccountsPayable'],item) :getValue(BalanceSheetData['quarterlyAccountsPayable'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
                <tr class="td-collapse">

                  <td>
                    <h3 class="bluelabel">Total Current Liabilities</h3>
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualCurrentLiabilities'],item) :getValue(BalanceSheetData['quarterlyCurrentLiabilities'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr>

                <td class="border-left">
                  <span class="btn-collapse" (click)="nonCurLiabilities = !nonCurLiabilities">
                    <i class="fa fa-angle-right" *ngIf="nonCurLiabilities" aria-hidden="true"></i>
                    <i class="fa fa-angle-down" *ngIf="!nonCurLiabilities" aria-hidden="true"></i>
                  </span>Non-Current Liabilities
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex" *ngIf="nonCurLiabilities">
                      {{ period==12 ? getValue(BalanceSheetData['annualOtherCurrentLiabilities'],item) :getValue(BalanceSheetData['quarterlyOtherCurrentLiabilities'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
              <ng-container *ngIf="!nonCurLiabilities">
                <tr class="td-collapse">

                  <td>
                    Long-Term Debt
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualLongTermDebt'],item) :getValue(BalanceSheetData['quarterlyLongTermDebt'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
                <!--<tr>

                    <td>
                        Deferred tax liabilities
                    </td>
                    <td *ngFor="let item of balanceSheet">
                        <p class="d-flex">

                            {{item?.otherCurrentAssets?.fmt}} No Value
                        </p>
                    </td>
                </tr>
                <tr>

                    <td>
                        Other long-term liabilities
                    </td>
                    <td *ngFor="let item of balanceSheet">
                        <p class="d-flex">

                            {{item?.otherLiab?.fmt}} No Value
                        </p>
                    </td>
                </tr>-->
                <tr class="td-collapse">

                  <td>
                    <h3 class="bluelabel">Total Non-Current Liabilities</h3>
                  </td>
                  <ng-container>
                    <td *ngFor="let item of balanceSheetDates">
                      <p class="d-flex">
                        {{ period==12 ? getValue(BalanceSheetData['annualOtherCurrentLiabilities'],item) :getValue(BalanceSheetData['quarterlyOtherCurrentLiabilities'],item) }}
                      </p>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
              <tr>

                <td>
                  <h3 class="bluelabel">Total Liabilities</h3>
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualTotalLiabilitiesNetMinorityInterest'],item) :getValue(BalanceSheetData['quarterlyTotalLiabilitiesNetMinorityInterest'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
            <tr>

              <td class="border-left">
                <span class="btn-collapse" (click)="stakeHolder = !stakeHolder">
                  <i class="fa fa-angle-right" *ngIf="stakeHolder" aria-hidden="true"></i>
                  <i class="fa fa-angle-down" *ngIf="!stakeHolder" aria-hidden="true"></i>
                </span>Stockholders' Equity
              </td>
              <ng-container>
                <td *ngFor="let item of balanceSheetDates">
                  <p class="d-flex" *ngIf="stakeHolder">
                    {{ period==12 ? getValue(BalanceSheetData['annualStockholdersEquity'],item) :getValue(BalanceSheetData['quarterlyStockholdersEquity'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <ng-container *ngIf="!stakeHolder">
              <tr class="td-collapse">

                <td>
                  Common Stock
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualCommonStock'],item) :getValue(BalanceSheetData['quarterlyCapitalStock'],item) }}
                    </p>
                  </td>
                </ng-container>

              </tr>
              <tr class="td-collapse">

                <td>
                  Retained Earnings
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualRetainedEarnings'],item) :getValue(BalanceSheetData['quarterlyRetainedEarnings'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
              <!--<tr>

                <td>
                  Accumulated Other Comprehensive Income
                </td>
                <td *ngFor="let item of balanceSheet">
                  <p class="d-flex">

                    {{item?.otherStockholderEquity?.fmt ? item?.otherStockholderEquity?.fmt :'-'}}
                  </p>
                </td>
              </tr>-->
              <tr>

                <td>
                  <h3 class="bluelabel">Total Stockholders' Equity</h3>
                </td>
                <ng-container>
                  <td *ngFor="let item of balanceSheetDates">
                    <p class="d-flex">
                      {{ period==12 ? getValue(BalanceSheetData['annualStockholdersEquity'],item) :getValue(BalanceSheetData['quarterlyStockholdersEquity'],item) }}
                    </p>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
            <tr>

              <td>
                <h3 class="bluelabel">Total Liabilities And Stockholders' equity</h3>
              </td>
              <ng-container>
                <td *ngFor="let item of balanceSheetDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(BalanceSheetData['annualTotalAssets'],item) :getValue(BalanceSheetData['quarterlyTotalAssets'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="typeId==3">
    <div class="d-flex margin-bottom-10 margin-top-15">
      <h3 class="bluelabel mr-auto margin-bottom-0">Cash flow &nbsp;&nbsp; <span style="font-size:8px;">All numbers in thousands</span></h3>
      <a class="a-normal" (click)="expand(false)" *ngIf="!isExpanded">Expand All</a>
      <a class="a-normal" (click)="expand(true)" *ngIf="isExpanded">Collapse All</a>
    </div>

    <div class="table-responsive">
      <table class="table basictable  finance-data-table row-border hover">
        <thead>
          <tr>
            <th>Breakdown</th>
            <th>TTM</th>
            <th *ngFor="let item of cashFlowDates">
              {{item | date:'MM/dd/yyyy'}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>

            <td class="border-left">
              <span class="btn-collapse" (click)="isCashFlow = !isCashFlow">
                <i class="fa fa-angle-right" *ngIf="isCashFlow" aria-hidden="true"></i>
                <i class="fa fa-angle-down" *ngIf="!isCashFlow" aria-hidden="true"></i>
              </span>Cash Flows From Operating Activities
            </td>
            <td>
              <p class="d-flex" *ngIf="isCashFlow">

                {{CashFlowData?.trailingOperatingCashFlow?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingOperatingCashFlow']) : '-'}}
              </p>
            </td>
            <ng-container>
              <td *ngFor="let item of cashFlowDates">
                <p class="d-flex" *ngIf="isCashFlow">
                  {{ period==12 ? getValue(CashFlowData['annualOperatingCashFlow'],item) :getValue(CashFlowData['quarterlyOperatingCashFlow'],item) }}
                </p>
              </td>
            </ng-container>
          </tr>
          <ng-container *ngIf="!isCashFlow">
            <tr class="ng-container">
              <td>
                Net Income
              </td>
              <td>
                {{CashFlowData?.trailingNetIncomeContinuousOperations?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingNetIncomeContinuousOperations']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualNetIncomeContinuousOperations'],item) :getValue(CashFlowData['quarterlyNetIncomeContinuousOperations'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <tr>

              <td>
                Depreciation & Amortisation
              </td>
              <td>
                {{CashFlowData?.trailingDepreciationAndAmortization?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingDepreciationAndAmortization']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualDepreciationAndAmortization'],item) :getValue(CashFlowData['quarterlyAccumulatedDepreciation'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <!--<tr>

              <td>
                Accounts Receivable
              </td>
              <td> {{cashFlow[0]?.changeToAccountReceivables?.fmt ? cashFlow[0]?.changeToAccountReceivables?.fmt : '-'}}</td>
              <td *ngFor="let item of cashFlow">
                <p class="d-flex">

                  {{item?.changeToAccountReceivables?.fmt ? item?.changeToAccountReceivables?.fmt : '-'}}
                </p>
              </td>
            </tr>-->
            <tr>

              <td>
                <h3 class="bluelabel">Net Cash Provided By Operating Activities</h3>
              </td>
              <td>
                {{CashFlowData?.trailingOperatingCashFlow?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingOperatingCashFlow']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualOperatingCashFlow'],item) :getValue(CashFlowData['quarterlyOperatingCashFlow'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr>

            <td class="border-left">
              <span class="btn-collapse" (click)="isCashFlowInvest = !isCashFlowInvest">
                <i class="fa fa-angle-right" *ngIf="isCashFlowInvest" aria-hidden="true"></i>
                <i class="fa fa-angle-down" *ngIf="!isCashFlowInvest" aria-hidden="true"></i>
              </span>
              Cash Flows From Investing Activities
            </td>
            <td>
              <p class="d-flex" *ngIf="isCashFlowInvest">

                {{CashFlowData?.trailingInvestingCashFlow?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingInvestingCashFlow']) : '-'}}
              </p>
            </td>
            <ng-container>
              <td *ngFor="let item of cashFlowDates">
                <p class="d-flex" *ngIf="isCashFlowInvest">
                  {{ period==12 ? getValue(CashFlowData['annualInvestingCashFlow'],item) :getValue(CashFlowData['quarterlyInvestingCashFlow'],item) }}
                </p>
              </td>
            </ng-container>
          </tr>
          <ng-container *ngIf="!isCashFlowInvest">
            <tr class="td-collapse">

              <td>
                Purchases Of Investments
              </td>
              <td>
                {{CashFlowData?.trailingPurchaseOfInvestment?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingPurchaseOfInvestment']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualPurchaseOfInvestment'],item) :getValue(CashFlowData['quarterlyPurchaseOfInvestment'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <tr class="td-collapse">

              <td>
                Net Business Purchase And Sale
              </td>
              <td>
                {{CashFlowData?.trailingPurchaseOfBusiness?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingPurchaseOfBusiness']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualPurchaseOfBusiness'],item) :getValue(CashFlowData['quarterlyPurchaseOfBusiness'],item) }}
                  </p>
                </td>
              </ng-container>

            </tr>
            <tr class="td-collapse">

              <td>
                <h3 class="bluelabel"> Net Cash Used ForInvesting Activities</h3>
              </td>
              <td>
                {{CashFlowData?.trailingInvestingCashFlow?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingInvestingCashFlow']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualInvestingCashFlow'],item) :getValue(CashFlowData['quarterlyInvestingCashFlow'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr>

            <td class="border-left">
              <span class="btn-collapse" (click)="cashFlowFinancing = !cashFlowFinancing">
                <i class="fa fa-angle-right" *ngIf="cashFlowFinancing" aria-hidden="true"></i>
                <i class="fa fa-angle-down" *ngIf="!cashFlowFinancing" aria-hidden="true"></i>
              </span>Cash Flows From Financing Activities
            </td>
            <td>
              <p class="d-flex" *ngIf="cashFlowFinancing">
                {{CashFlowData?.trailingFinancingCashFlow?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingFinancingCashFlow']) : '-'}}

              </p>
            </td>
            <ng-container>
              <td *ngFor="let item of cashFlowDates">
                <p class="d-flex">
                  {{ period==12 ? getValue(CashFlowData['annualFinancingCashFlow'],item) :'-' }}
                </p>
              </td>
            </ng-container>
          </tr>
          <ng-container *ngIf="!cashFlowFinancing">

            <tr class="td-collapse">

              <td>
                Common Stock Repurchased
              </td>
              <td>
                {{CashFlowData?.trailingRepurchaseOfCapitalStock?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingRepurchaseOfCapitalStock']) : '-'}}

              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualRepurchaseOfCapitalStock'],item) :getValue(CashFlowData['quarterlyRepurchaseOfCapitalStock'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <tr class="td-collapse">

              <td>
                Dividends Paid
              </td>
              <td>
                {{CashFlowData?.trailingCashDividendsPaid?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingCashDividendsPaid']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualCashDividendsPaid'],item) :getValue(CashFlowData['quarterlyCashDividendsPaid'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <!--<tr class="td-collapse">

              <td>
                Other Financing Activities
              </td>
              <td>
                {{cashFlow[0]?.otherCashflowsFromFinancingActivities?.fmt ? cashFlow[0]?.otherCashflowsFromFinancingActivities?.fmt :'-'}}
              </td>
              <td *ngFor="let item of cashFlow">
                <p class="d-flex">

                  {{item?.otherCashflowsFromFinancingActivities?.fmt ? item?.otherCashflowsFromFinancingActivities?.fmt :'-'}}
                </p>
              </td>
            </tr>-->
            <tr class="td-collapse">

              <td>
                <h3 class="bluelabel">Net Cash Used Provided By (Used For) Financing Activities</h3>
              </td>
              <td>
                {{CashFlowData?.trailingFinancingCashFlow?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingFinancingCashFlow']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualFinancingCashFlow'],item) :'-' }}
                  </p>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <!--<tr>

            <td class="border-left">
              <span class="btn-collapse" (click)="isFreeCashFlow = !isFreeCashFlow">
                <i class="fa fa-angle-right" *ngIf="isFreeCashFlow" aria-hidden="true"></i>
                <i class="fa fa-angle-down" *ngIf="!isFreeCashFlow" aria-hidden="true"></i>
              </span>Free Cash Flow
            </td>
            <td>
              <p class="d-flex" *ngIf="isFreeCashFlow">
                {{freeCashFlow(cashFlow[0]?.totalCashFromOperatingActivities?.longFmt, cashFlow[0]?.capitalExpenditures?.longFmt)| shortNumber}}

              </p>
            </td>
            <td *ngFor="let item of cashFlow">
              <p class="d-flex" *ngIf="isFreeCashFlow">
                {{freeCashFlow(item.totalCashFromOperatingActivities?.longFmt, item?.capitalExpenditures?.longFmt)| shortNumber}}

              </p>
            </td>
          </tr>-->
          <ng-container *ngIf="!isFreeCashFlow">
            <tr class="td-collapse">

              <td>
                Operating Cash Flow
              </td>
              <td>
                {{CashFlowData?.trailingOperatingCashFlow?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingOperatingCashFlow']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualOperatingCashFlow'],item) :getValue(CashFlowData['quarterlyOperatingCashFlow'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <tr class="td-collapse">

              <td>
                Capital Expenditure
              </td>
              <td>
                {{CashFlowData?.trailingCapitalExpenditure?.length > 0 ? getTrailingValuesValue(CashFlowData['trailingCapitalExpenditure']) : '-'}}
              </td>
              <ng-container>
                <td *ngFor="let item of cashFlowDates">
                  <p class="d-flex">
                    {{ period==12 ? getValue(CashFlowData['annualCapitalExpenditure'],item) :getValue(CashFlowData['quarterlyCapitalExpenditure'],item) }}
                  </p>
                </td>
              </ng-container>
            </tr>
            <!--<tr class="td-collapse">

              <td>
                <h3 class="bluelabel">Free Cash Flow</h3>
              </td>
              <td>
                {{freeCashFlow(cashFlow[0]?.totalCashFromOperatingActivities?.longFmt, cashFlow[0]?.capitalExpenditures?.longFmt)| shortNumber}}
              </td>
              <td *ngFor="let item of cashFlow">
                <p class="d-flex">

                  {{freeCashFlow(item.totalCashFromOperatingActivities?.longFmt, item?.capitalExpenditures?.longFmt)| shortNumber}}

                </p>
              </td>
            </tr>-->
          </ng-container>
        </tbody>
      </table>
    </div>

  </div>
</div>
